/**
 *  interface for Login Type
 */
export enum RegisterTypes {
  REGISTER_USER = '@@register/REGISTER_USER',
  REGISTER_USER_SUCCESSFUL = '@@register/REGISTER_USER_SUCCESSFUL',
  REGISTER_USER_FAILED = '@@register/REGISTER_USER_FAILED',
}
